import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Label from '../label/Label';
import Select from '../select/Select';
import HelpWrapper from '../help/HelpWrapper';
import Popover from '../popover/Popover';
import Error from '../error/Error';
import useAriaProps from '../hooks/useAriaProps';

function SelectGroup(_ref) {
  var self = _ref.self,
      label = _ref.label,
      select = _ref.select,
      popover = _ref.popover,
      size = _ref.size;
  var cssClass = classNames('tds-form__group', self.classNames);
  var hasPopoverHelp = self.helpText && popover;
  var hasStaticHelp = self.helpText && !popover;

  var _useAriaProps = useAriaProps(self.groupId, self.error),
      errorDescribeId = _useAriaProps.errorDescribeId,
      ariaProps = _useAriaProps.ariaProps;

  var renderedInput = /*#__PURE__*/React.createElement(Select, _extends({
    id: self.groupId
  }, select, {
    error: !!self.error
  }, ariaProps));
  var wrappedInput = hasPopoverHelp ? /*#__PURE__*/React.createElement(Popover, _extends({
    onFocusBehavior: true,
    content: self.helpText,
    theme: self.helpFormat
  }, popover), renderedInput) : renderedInput;
  return /*#__PURE__*/React.createElement("div", {
    className: cssClass
  }, /*#__PURE__*/React.createElement(Label, _extends({
    size: size,
    htmlFor: self.groupId
  }, label, {
    disabled: select.disabled,
    inverse: label.inverse || select.inverse
  })), hasStaticHelp && /*#__PURE__*/React.createElement(HelpWrapper, {
    classNames: self.helpClassNames,
    format: self.helpFormat,
    theme: self.helpTheme
  }, self.helpText), wrappedInput, /*#__PURE__*/React.createElement(Error, {
    id: "error_".concat(errorDescribeId),
    error: self.error
  }));
}

SelectGroup.displayName = "SelectGroup";
SelectGroup.propTypes = {
  self: PropTypes.shape({
    classNames: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    groupId: PropTypes.string,
    helpText: PropTypes.node,
    helpFormat: PropTypes.string,
    helpTheme: PropTypes.string,
    helpClassNames: PropTypes.string,
    error: Error.propTypes.error,
    size: PropTypes.string
  }).isRequired,
  label: PropTypes.shape({
    hide: PropTypes.bool,
    inverse: PropTypes.bool,
    inline: PropTypes.bool,
    emphasis: PropTypes.bool,
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
  }),
  select: PropTypes.shape({
    classNames: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    inverse: PropTypes.bool,
    options: PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string
    })).isRequired,
    hideBorder: PropTypes.bool,
    disabled: PropTypes.bool,
    size: PropTypes.oneOf(['sm', 'lg', 'md'])
  }),
  popover: PropTypes.shape({
    className: PropTypes.string,
    title: PropTypes.string,
    icon: PropTypes.string,
    placement: PropTypes.oneOf(['top', 'bottom', 'left', 'right', 'auto']),
    width: PropTypes.number,
    push: PropTypes.oneOf(['left', 'right']),
    closable: PropTypes.bool,
    tooltipBehavior: PropTypes.bool,
    forceCloseOnClick: PropTypes.bool,
    onToggle: PropTypes.func,
    onClosed: PropTypes.func,
    animated: PropTypes.bool
  }),
  size: PropTypes.oneOf(['sm', 'lg', 'md'])
};
SelectGroup.defaultProps = {
  label: {},
  select: {},
  popover: null,
  size: 'md'
};
export default SelectGroup;